import React, { useContext, useEffect, useState } from 'react'

import { firestore } from '../../firebase';
import { MDBContainer } from 'mdbreact';
import { Pie } from "react-chartjs-2";

import StateContext from '../../StateContext';

function UserBudgetDonutChart() {

    const appState = useContext(StateContext)

    const [labels, setLabels] = useState([]);
    const [data, setData] = useState([]);

    const state = {
        dataPie: {
        labels: labels,
        datasets: [
            {
            data: data,
            backgroundColor: [
                "#F7464A",
                "#46BFBD",
                "#FDB45C",
                "#949FB1",
                "#4D5360",
                "#AC64AD",
                "#990000",
                "#660066",
                "#0000e6",
                "#00a3cc",
                "#ac7339",
                "#00b3b3",
                "#4ce600",
                "#000000"
            ],
            hoverBackgroundColor: [
                "#FF5A5E",
                "#5AD3D1",
                "#FFC870",
                "#A8B3C5",
                "#616774",
                "#DA92DB",
                "#cc0000",
                "#ff00ff",
                "#4d4dff",
                "#1ad1ff",
                "#734d26",
                "#00e6e6",
                "#77ff33",
                "#194d00"
            ]
            }
        ]
        }
    }

    useEffect(() => {
        try {
            const totalExpenseRef = firestore.collection("users").doc(appState.userId).collection("total-budget-categories");
            totalExpenseRef.onSnapshot(({docs}) => {
                const expenses = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                const data = expenses.map(expense => {
                    return expense.sum;
                })
                const labels = expenses.map(expense => {
                    return expense.category;
                })
                setData(data);
                setLabels(labels);
            })
        } catch (error) {
            
        }
    }, [appState.userId])

    return (
        <MDBContainer>         
            <h3 className="mt-5">Utgifter</h3>
            {data && labels && <Pie data={state.dataPie} options={{ responsive: true }} />}
            
        </MDBContainer>
    )

}
export default UserBudgetDonutChart